import { useEffect, useState } from 'react';
import axios from 'axios';

interface Holiday {
  ['@odata.etag']: string;
  new_date: string;
  new_axspublicholidaysid: string;
}

export const useGetHolidays = () => {
  const [holidays, setHolidays] = useState<Array<string>>([]);

  const getHolidays = async () => {
    try {
      const response = await axios.get('api/public-holidays');
      const holidays: Array<string> = response.data.map(
        (holiday: Holiday) => holiday.new_date
      );
      setHolidays(holidays);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    getHolidays();
  }, []);

  return { holidays };
};
